// extracted by mini-css-extract-plugin
module.exports = {"container":"SocialBar_container__2D4_D","link":"SocialBar_link__21vX6"};